import { z } from 'zod'

const PartialI18nSchema = z.object({
  english: z.string().optional(),
  spanish: z.string().optional()
})

export const TutorialStepCopySchema = z.object({
  title: PartialI18nSchema.optional(),
  body: PartialI18nSchema.optional(),
  actionHint: PartialI18nSchema.optional(),
  manualLabel: PartialI18nSchema.optional()
})

export const TutorialTourCopySchema = z.object({
  pickerTitle: PartialI18nSchema.optional(),
  pickerDescription: PartialI18nSchema.optional(),
  finaleTitle: PartialI18nSchema.optional(),
  finaleBody: PartialI18nSchema.optional()
})

export const TutorialCopySchema = z.object({
  tours: z.record(TutorialTourCopySchema),
  steps: z.record(TutorialStepCopySchema)
})

export type IPartialI18nString = z.infer<typeof PartialI18nSchema>
export type ITutorialStepCopy = z.infer<typeof TutorialStepCopySchema>
export type ITutorialTourCopy = z.infer<typeof TutorialTourCopySchema>
export type ITutorialCopy = z.infer<typeof TutorialCopySchema>

export interface ISanityTutorialCopy {
  tours: ({ tourId: string | null } & ITutorialTourCopy)[] | null
  steps: ({ stepId: string | null } & ITutorialStepCopy)[] | null
}

const keyBy = <T extends { [key: string]: unknown }>(
  items: T[] | null,
  idField: keyof T
) =>
  Object.fromEntries(
    (items ?? [])
      .filter((item) => typeof item[idField] === 'string')
      .map(({ [idField]: id, ...copy }) => [id, copy])
  )

export const transformSanityTutorialCopy = (
  raw: ISanityTutorialCopy
): ITutorialCopy => ({
  tours: keyBy(raw.tours, 'tourId'),
  steps: keyBy(raw.steps, 'stepId')
})
